import React, { createContext, useContext } from "react";
import { Config } from "../types";

const ConfigContext = createContext<Config>({
  defaultLang: "",
  googleAnalyticsKey: "",
  name: "",
  shortName: "",
  template: "fresh",
});

const ConfigProvider: React.FC<{ config: Config }> = ({ children, config }) => {
  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};

const useConfig = () => useContext(ConfigContext);

export { ConfigProvider, useConfig };
